import React from 'react';
import { Edit } from 'react-admin';
import { t } from 'i18next';

import EditFormTitle from '../EditFormTitle';
import { CustomEditToolbar } from '../CustomEditToolbar';
import { CountryForm } from './CountryForm';

export const CountryEdit = props => (
  <Edit {...props} title={<EditFormTitle formName={t("countries.country")} />}>
    <CountryForm toolbar={<CustomEditToolbar user={props.options.currentUser.role}/>} />
  </Edit>
);
